// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1002;\n  background-color: var(--lightest-color);\n  padding: 20px;\n  color: var(--danger-color);\n  font-size: 2.5em;\n}\n", ""]);
// Exports
module.exports = exports;
